<script>
  export default {
    props: {
      sticky: {
        type: String,
        default: '250px'
      }
    },
    data() {
      return {
        scrollTop: 0,
        scrollTopCache: 0,
        stickyMinus: 0,
        scrollWay: '',
        stickyTop: 0,
      }
    },
    computed: {
      // styleList() {
      //   let styleSticky = {};
      //   if (this.stickyMinus < 0) {
      //     styleSticky = {
      //       top: this.sticky,
      //     }
      //   } else if(this.stickyMinus > 0){
      //     if (this.scrollWay === 'top') {
      //       styleSticky = {
      //         // top: this.stickyMinus + 'px',
      //         // transform: 'translateY(-200px)',
      //         //  bottom: '-1000px',
      //         // top: -this.stickyMinus + 'px',
      //         top: this.sticky,
      //         //  position: 'relative'
      //       }
      //     } else if (this.scrollWay === 'bottom') {
      //       styleSticky = {
      //         top: -this.stickyMinus + 'px',
      //       }
      //     }
      //   }
      //   return styleSticky
      // },
    },
    mounted() {
      // this.onScroll();
      // window.addEventListener('scroll', this.onScroll);

      // let stickyHeight = this.$refs.sticky.offsetHeight;
      // let visableHeight = document.documentElement.clientHeight;

      // this.stickyMinus = stickyHeight - visableHeight;
      // this.stickyTop = this.$refs.sticky.getBoundingClientRect().top;
    },
    destroyed() {
      // window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
      // onScroll() {
      //   this.scrollTop = this.getWindowScrollTop();

      //   let scroll = this.scrollTop - this.scrollTopCache; // 設定一個滾動暫存值，取得現在的滾動和暫存值的差
      //   this.scrollTopCache = this.scrollTop; // 每次滾動要把暫存值更新成這次的滾動值

      //   if (scroll < 0) {
      //     this.scrollWay = 'top'
      //   } else if (scroll > 0) {
      //     this.scrollWay = 'bottom'
      //   }
      // },
      // getWindowScrollTop() {
      //   let windowScrollTop = 0;

      //   if (typeof window.pageYOffset !== 'undefined') {
      //     windowScrollTop = window.pageYOffset
      //   } else if (typeof document.compatMode !== 'undefined' && document.compatMode !== 'BackCompat') {
      //     windowScrollTop = document.documentElement.scrollTop
      //   } else if (typeof document.body !== 'undefined') {
      //     windowScrollTop = document.body.scrollTop
      //   }
      //   return windowScrollTop
      // },
    },
  }
</script>
<template>
  <div ref="sticky" :class="$style.sticky" :style="sticky">
    <slot/>
  </div>
</template>
<style lang="scss" module>
  .sticky {
    position: sticky;
    top: 250px;
    z-index: 1;
    padding-bottom: 6rem;
    transition: all 0.8s;

    @include max-lg {
      position: static;
    }
  }
</style>
